import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, Card, Tabs, Select, List,
  message, Tag, Typography, Space, Divider, Popover, TreeSelect,
  Checkbox} from "antd";
import { BugOutlined, UserOutlined, PaperClipOutlined, CloseOutlined} from "@ant-design/icons";
import "./ReportBug.css";
import AwsServerService from "../common/util/AwsServerService";
import { modifyTimezoneString } from "../components/HR/TimeClock/Util";
import ScreenCapture from "./ScreenCapture";
import ReportBugActivity from "./ReportBugActivity";
import ReportBugComments from "./ReportBugComments";
import BugFiltersPopover from "./BugFilterPopover";
import { Collapse } from "antd";
import WorkDriveUI from "./WorkDriveUI";
const { Panel } = Collapse;
const { Text, Title } = Typography; 
const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;

export default function ReportBug({history}) {
  const BUG_REPORTS = "spj7mce20634e4be04834bbc7218971e3abfb";
  const userInfo = JSON.parse(localStorage.getItem("userinfo"));
  const [activeTab, setActiveTab] = useState("1");
  const [refreshBugs, setRefreshBugs] = useState(false);
  const [form] = Form.useForm();
  const [bugs, setBugs] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [popoveropen, setPopoverOpen] = useState(false);
  const [editingBug, setEditingBug] = useState(null);
  const [allBugs, setAllBugs] = useState([]);
  const isDev = userInfo?.email_id === "aditya@srsolardesign.com";
  const moduleMap = ["Accounting", "Calendar", "Documents", "Email"];
  
  const [selectedBugIds, setSelectedBugIds] = useState([]);
  const [buckets, setBuckets] = useState({
    HighPriority: [],
    MediumPriority: [],
    LowPriority: [],
    Similar: [],
    UnCategorized: []
  });
  const [activePopoverBugId, setActivePopoverBugId] = useState(null);
  const [isBucketPopoverOpen, setIsBucketPopoverOpen] = useState(false);
  const CLASSPICKER = {
    "In Progress":"BugStatusSelectorIP", "Open":"BugStatusSelectorON", "Closed":"BugStatusSelectorCL"
   }

   const Setting={
      users : "Users", roles : "Roles",
      emailTemplate: "Email Template", userroles : "User Roles Assignments",
      teams : "Teams", SecurityControl : "Security Control" ,
      taskflows : "Task Flows", pipeline : "Pipeline"
  }
  const getStatusColor = (status) => {
    switch (status) {
      case "Open":
        return "red";
      case "In Progress":
        return "orange";
      case "Closed":
        return "green";
      default:
        return "blue";
    }
  }; 

  const handleEditBug = (values, attachaments)=>{
    const payload = {
        ROWID: editingBug.ROWID,
        Title: values.title,
        Module: values.module,
        Attachments: JSON.stringify(attachaments),
        MODIFIEDBY: userInfo?.email_id,
        Description: values.description,
        LastUpdateFullName: (userInfo?.first_name + " " + userInfo?.last_name) || userInfo?.email_id,
        LastUpdateZuid: localStorage.getItem("ZUID")
      };
      AwsServerService.updateBug(payload).then(() => {
        message.success({ content: "Bug updated successfully!", key: "submit", duration: 2 });
        setEditingBug(null);
        form.resetFields();
        setFileList([]);
        setRefreshBugs(prev => !prev);
      }).catch(() => {
        message.error({ content: "Failed to update bug.", key: "submit", duration: 2 });
      });
  }
  const handleSubmit = (values) => {debugger
    message.loading({ content: "Submitting bug...", key: "submit", duration: 0 });

    if (editingBug) {
      let shouldUpload = false;
      let newAttachments = [];
      let existingAttachments = editingBug.Attachments || [];
      let attachments = fileList.filter(f => f.uid !== undefined).map(f => f.name);
      existingAttachments = existingAttachments ? existingAttachments.filter(att => attachments.includes(att)) : [];
      if (fileList.length > 0) {
       if(existingAttachments.length !== attachments.length) {
        shouldUpload = true;
        newAttachments = fileList.filter(att => !existingAttachments.includes(att?.name));
       }
      }
      if(shouldUpload) {
        uploadFileToFolder(values, newAttachments, existingAttachments);
        return;
      }
      handleEditBug(values, existingAttachments);
    } else {
      uploadFileToFolder();
    }
  };
  useEffect(()=>{
  if(activeTab == "3"){
    const bucketsData = { HighPriority: [], MediumPriority: [], LowPriority: [], Similar: [], UnCategorized: [] };
     AwsServerService.getAllBugReport(userInfo?.email_id).then(res => {
      AwsServerService.getBugCommentsUnreadCount(userInfo?.email_id).then(countRes => {
        const countData = countRes.data[0] || [];
        const bugsWithCount = res.data.map(bug => {
          const countObj = countData.find(c => c.BugRowId === bug.ROWID);
          bucketsData[bug["BucketName"] || "UnCategorized"].push(bug);
          return { ...bug, UnReadCount: countObj?.UnreadCount || 0 };
        });
      setBuckets(bucketsData);
      setBugs(bugsWithCount);
      setAllBugs(bugsWithCount);
      })
    }).catch(() => {
      setBugs([]);
    });
  }
  },[activeTab])

  useEffect(() => {
    AwsServerService.getAllBugReport(userInfo?.email_id).then(res => {
      AwsServerService.getBugCommentsUnreadCount(userInfo?.email_id).then(countRes => {
        const countData = countRes.data[0] || [];
        const bugsWithCount = res.data.map(bug => {
          const countObj = countData.find(c => c.BugRowId === bug.ROWID);
          return { ...bug, UnReadCount: countObj?.UnreadCount || 0 };
        });
      setBugs(bugsWithCount);
      setAllBugs(bugsWithCount);
      })
    }).catch(() => {
      setBugs([]);
    });
  }, [refreshBugs]); 

  const treeData = [
    { title: 'Home', value: 'Home', key: 'Home', fullLabel: 'Home' },
    {
      title: 'Accounts',
      value: 'Accounts',
      key: 'Accounts',
      fullLabel: 'Accounts',
      children: [
        { title: 'Dashboard', value: 'Accounts ›› Dashboard', key: 'Accounts ›› Dashboard', fullLabel: 'Dashboard (Accounts)' },
        { title: 'List View', value: 'Accounts ›› List View', key: 'Accounts ›› List View', fullLabel: 'List View (Accounts)' },
        { title: 'Create', value: 'Accounts ›› Create', key: 'Accounts ›› Create', fullLabel: 'Create (Accounts)' },
        { title: 'Edit', value: 'Accounts ›› Update', key: 'Accounts ›› Update', fullLabel: 'Edit (Accounts)' }
      ]
    },
    {
      title: 'Vendors',
      value: 'Vendors',
      key: 'Vendors',
      fullLabel: 'Vendors',
      children: [
        { title: 'Dashboard', value: 'Vendors ›› Dashboard', key: 'Vendors ›› Dashboard', fullLabel: 'Dashboard (Vendors)' },
        { title: 'List View', value: 'Vendors ›› List View', key: 'Vendors ›› List View', fullLabel: 'List View (Vendors)' },
        { title: 'Create', value: 'Vendors ›› Create', key: 'Vendors ›› Create', fullLabel: 'Create (Vendors)' },
        { title: 'Edit', value: 'Vendors ›› Update', key: 'Vendors ›› Update', fullLabel: 'Edit (Vendors)' }
      ]
    },
    {
      title: 'Deals',
      value: 'Deals',
      key: 'Deals',
      fullLabel: 'Deals',
      children: [
        { title: 'Dashboard', value: 'Deals ›› Dashboard', key: 'Deals ›› Dashboard', fullLabel: 'Dashboard (Deals)' },
        { title: 'List View', value: 'Deals ›› List View', key: 'Deals ›› List View', fullLabel: 'List View (Deals)' },
        { title: 'Create', value: 'Deals ›› Create', key: 'Deals ›› Create', fullLabel: 'Create (Deals)' },
        { title: 'Edit', value: 'Deals ›› Update', key: 'Deals ›› Update', fullLabel: 'Edit (Deals)' }
      ]
    },
    {
      title: 'Leads',
      value: 'Leads',
      key: 'Leads',
      fullLabel: 'Leads',
      children: [
        { title: 'Dashboard', value: 'Leads ›› Dashboard', key: 'Leads ›› Dashboard', fullLabel: 'Dashboard (Leads)' },
        { title: 'List View', value: 'Leads ›› List View', key: 'Leads ›› List View', fullLabel: 'List View (Leads)' },
        { title: 'Create', value: 'Leads ›› Create', key: 'Leads ›› Create', fullLabel: 'Create (Leads)' },
        { title: 'Edit', value: 'Leads ›› Update', key: 'Leads ›› Update', fullLabel: 'Edit (Leads)' }
      ]
    },
    { title: 'Tasks', value: 'Tasks', key: 'Tasks', fullLabel: 'Tasks' },
    { title: 'Quotes', value: 'Quotes', key: 'Quotes', fullLabel: 'Quotes' },
    { title: 'Accounting', value: 'Accounting', key: 'Accounting', fullLabel: 'Accounting' },
    { title: 'Time Clock', value: 'Time Clock', key: 'Time Clock', fullLabel: 'Time Clock' },
    { title: 'Documents', value: 'Documents', key: 'Documents', fullLabel: 'Documents' },
    { title: 'Calendar', value: 'Calendar', key: 'Calendar', fullLabel: 'Calendar' },
    { title: 'Email', value: 'Email', key: 'Email', fullLabel: 'Email' },
    { title: 'Chat', value: 'Chat', key: 'Chat', fullLabel: 'Chat' },
    { title: 'Reminder', value: 'Reminder', key: 'Reminder', fullLabel: 'Reminder' },
    { title: 'Notification', value: 'Notification', key: 'Notification', fullLabel: 'Notification' },
    { title: 'Check In/Out', value: 'Check In/Out', key: 'Check In/Out', fullLabel: 'Check In/Out' },
    { title: 'Users', value: 'Users', key: 'Users', fullLabel: 'Users' },
    { title: 'Roles', value: 'Roles', key: 'Roles', fullLabel: 'Roles' },
    { title: 'Email Template', value: 'Email Template', key: 'Email Template', fullLabel: 'Email Template' },
    { title: 'User Roles Assignments', value: 'User Roles Assignments', key: 'User Roles Assignments', fullLabel: 'User Roles Assignments' },
    { title: 'Teams', value: 'Teams', key: 'Teams', fullLabel: 'Teams' },
    { title: 'Security Control', value: 'Security Control', key: 'Security Control', fullLabel: 'Security Control' },
    { title: 'Task Flows', value: 'Task Flows', key: 'Task Flows', fullLabel: 'Task Flows' },
    { title: 'Pipeline', value: 'Pipeline', key: 'Pipeline', fullLabel: 'Pipeline' },
    { title: 'Contacts', value: 'Contacts', key: 'Contacts', fullLabel: 'Contacts' },
  ];

  const getBreadcrumb = (pathname) => {
  if (pathname.includes("timeclock")) return "Time Clock"; 
  if (pathname.includes("Deals/DetailView")) return "Deals ›› Dashboard";
  if (pathname.includes("Deals/listview")) return "Deals ›› List View";
  if (pathname.includes("Deals/create")) return "Deals ›› Create";
  if (pathname.includes("Deals/Update")) return "Deals ›› Update";
  if (pathname.includes("Deals")) return "Deals";
  if (pathname.includes("Tasks")) return "Tasks"; 
  if (pathname.includes("Accounts/DetailView")) return "Accounts ›› Dashboard";
  if (pathname.includes("Accounts/listview")) return "Accounts ›› List View";
  if (pathname.includes("Accounts/create")) return "Accounts ›› Create";
  if (pathname.includes("Accounts/Update")) return "Accounts ›› Update";
  if (pathname.includes("Accounts")) return "Accounts"; 
  if (pathname.includes("Vendors/DetailView")) return "Vendors ›› Dashboard";
  if (pathname.includes("Vendors/listview")) return "Vendors ›› List View";
  if (pathname.includes("Vendors/create")) return "Vendors ›› Create";
  if (pathname.includes("Vendors/Update")) return "Vendors ›› Update";
  if (pathname.includes("Vendors")) return "Vendors";
  if (pathname.includes("Leads/DetailView")) return "Leads ›› Dashboard";
  if (pathname.includes("Leads/listview")) return "Leads ›› List View";
  if (pathname.includes("Leads/create")) return "Leads ›› Create";
  if (pathname.includes("Leads/Update")) return "Leads ›› Update";
  if (pathname.includes("Leads")) return "Leads ›› List View";
  if (pathname.includes("Document")) return "Documents";
  return "";
};

   const getModuleFromPath = (pathname) => {
    if(!pathname) return "Home";
    return Setting[pathname.split("setting/")[1]?.split("/")[0]] || "Home";
   }

  const handleTreeSelectChange = (value) => {
    const findNode = (nodes) => {
      for (let node of nodes) {
        if (node.value === value) {
          return node.fullLabel || node.title;
        }
        if (node.children) {
          const found = findNode(node.children);
          if (found) return found;
        }
      }
      return null;
    };
  }

  const getDisplayLabel = (value) => {
    const findNode = (nodes) => {
      for (let node of nodes) {
        if (node.value === value) {
          return node.fullLabel || node.title;
        }
        if (node.children) {
          const found = findNode(node.children);
          if (found) return found;
        }
      }
      return null;
    };
    return findNode(treeData) || value;
  }

  const CustomTreeSelectWrapper = ({ value, onChange, treeData, ...props }) => {
    const displayLabel = value ? getDisplayLabel(value) : '';
    const [isOpen, setIsOpen] = useState(false);
    
    return (
      <div style={{ position: 'relative' }}>
        <TreeSelect
          {...props}
          treeData={treeData}
          value={value || undefined}
          onChange={(val) => {
            onChange(val);
            setIsOpen(false);
          }}
          onDropdownVisibleChange={setIsOpen}
        />
        {displayLabel && value && !isOpen && (
          <span
            style={{
              position: 'absolute',
              left: 12,
              top: '50%',
              transform: 'translateY(-50%)',
              pointerEvents: 'none',
              fontSize: '14px',
              color: '#000000',
              lineHeight: 1.5,
            }}
          >
            {displayLabel}
          </span>
        )}
      </div>
    );
  };

  async function findFolder(userEmail, token) {
    const res = await AwsServerService.fetchWorkdriveFolderById(BUG_REPORTS, token);
    let folder = res?.data.data.find(
      f => f.attributes.name === `Bug Reports - ${userEmail}` && f.attributes.type === "folder"
    );
    return folder ? folder.id : null;
  }

  async function getUserFolder(userEmail, token) {
    let data = await AwsServerService.getUserById(userEmail);
    let folderId = data.data[0]?.BugReportsFolderId;
    if (folderId) return folderId;
    folderId = await findFolder(userEmail, token);
    if (!folderId) {
      folderId = await createFolder(data.data[0], userEmail, token);
      if (!folderId) return null;
    }
    return folderId;
  }

  async function createFolder(data, userEmail, token) {
    const res = await AwsServerService.createWorkdriveFolder(BUG_REPORTS, `Bug Reports - ${userEmail}`, token);
    await AwsServerService.updateUserById({
      ROWID: data?.ROWID,
      BugReportsFolderId: res?.data?.data?.id
    });
    return res?.data.data ? res?.data.data.id : null;
  }

  async function uploadFileToFolder(values, newAttachments = [], existingAttachments = []) {
    const TOKEN = localStorage.getItem("token");
    const USEREMAIL = userInfo?.email_id;
    let files = [];
    if (editingBug){
      files = newAttachments.map(f => f.originFileObj || f);
    }else{
      files = fileList.map(f => f.originFileObj || f);
    }

    getUserFolder(USEREMAIL, TOKEN).then(async (folderId) => {
        if (folderId) {
          let array = [];
          for (let file of files) {
            await AwsServerService.UploadFileWorkDrive(file, folderId, TOKEN).then(res => {
              if (res?.data?.data[0]?.attributes?.resource_id) {
                array.push(res?.data?.data[0]?.attributes?.resource_id);
              }
            }).catch(() => { message.error({ content: `Failed to upload file: ${file.name}`, key: "submit", duration: 2 });});
          }
          if(editingBug){
            handleEditBug(values, [...existingAttachments, ...array]);
            return;
          }
          const payload = {
            CREATEDBY: USEREMAIL,
            Title: form.getFieldValue("title"),
            Module: form.getFieldValue("module"),
            LastUpdateFullName: (userInfo?.first_name + " " + userInfo?.last_name) || userInfo?.email_id,
            LastUpdateZuid: localStorage.getItem("ZUID"),
            Description: form.getFieldValue("description"),
            BugStatus: "Open",
            Attachments: JSON.stringify(array)
          };
          AwsServerService.createBugReport(payload).then(async (res) => {
            message.success({ content: "Bug reported successfully!", key: "submit", duration: 2 });
            setFileList([]);
            form.resetFields();
            setRefreshBugs(prev => !prev);
              const activitydata = {
                BugRowId: res?.data?.id,
                Owner: localStorage.getItem("ZUID"),
                OwnerName: (userInfo?.first_name + " " + userInfo?.last_name) || userInfo?.email_id,
                Message: "reported a new bug : " + payload.Title,
              }
            await AwsServerService.createBugActivity(activitydata);
          });
        } else {
          message.error({ content: "Failed to get or create folder for bug reports.", key: "submit", duration: 2 });
        }
      }).catch(() => {
        message.error({ content: "Error getting user folder!!!", key: "submit", duration: 2 });
      });
  }

  const handleEdit = (bug) => {
    setEditingBug(bug);
    form.setFieldsValue({ title: bug.Title, module: bug.Module, description: bug.Description }); 
    setFileList(bug.Attachments ? bug.Attachments.map((file, index) => ({ uid: index, name: file })) : []);
    setActiveTab("1");
  };

  const handleStatusChange = (bug, newStatus) => {
    const payload = {
      ROWID: bug.ROWID,
      BugStatus: newStatus,
      MODIFIEDBY: userInfo?.email_id,
      LastUpdateFullName: (userInfo?.first_name + " " + userInfo?.last_name) || userInfo?.email_id,
      LastUpdateZuid: localStorage.getItem("ZUID")
    };
    AwsServerService.updateBug(payload).then(() => {
      setBugs(prev => prev.map(b => (b.ROWID === bug.ROWID ? { ...b, BugStatus: newStatus } : b)));
    });
  };

  const attachmentContent = (
    <div>
      {fileList.length === 0 ? (<p>No attachments</p>) : (
        <><List
            size="small"
            dataSource={fileList}
            renderItem={(file) => (
              <List.Item
                actions={[
                  <CloseOutlined
                    style={{ color: "red" }}
                    onClick={() => setFileList(prev => prev.filter(f => f.uid !== file.uid))}
                  />
                ]}>{file.name}</List.Item>)}/>
          <Button danger size="small" style={{ marginTop: 10 }} onClick={() => setFileList([])}>
            Remove All </Button>
        </>
      )}
    </div>
  );

const renderBugCard = (bug) => {
  return (
    <Card hoverable style={isBucketPopoverOpen ? { borderRadius: "12px", height: "100%", width:"380px", 
    display: "flex",
    flexDirection: "column"
     } : { borderRadius: "12px" }} 
     >
      <Space style={{ width: "100%", justifyContent: "space-between" }}>
        <Space>
          <Checkbox
            checked={selectedBugIds.includes(bug.ROWID)}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedBugIds(prev => [...prev, bug.ROWID]);
              } else {
                setSelectedBugIds(prev => prev.filter(id => id !== bug.ROWID));
              }
            }}
          />
          <BugOutlined style={{ color: "#ff4d4f" }} />
          <Title level={5} style={{ margin: 0 }}>{bug.Title}</Title>
        </Space>

        {isDev ? (
          <Select
            rootClassName={CLASSPICKER[bug.BugStatus]}
            size="small"
            value={bug.BugStatus}
            onChange={(val) => handleStatusChange(bug, val)}
            style={{ width: 90,height: "auto" }}
          >
            <Option value="Open">Open</Option>
            <Option value="In Progress">In Progress</Option>
            <Option value="Closed">Closed</Option>
          </Select>
        ) : (
          <> 
            {bug.BugStatus == "Closed" ? (
              <Select
                rootClassName={CLASSPICKER[bug.BugStatus]}
                size="small"
                value={bug.BugStatus}
                onChange={(val) => handleStatusChange(bug, val)}
                style={{ width: 90,height: "auto" }}
              >
                <Option value="Open">Reopen</Option>
              </Select>
            ):<Tag color={getStatusColor(bug.BugStatus)}>{bug.BugStatus}</Tag>}
          </>
        )}
      </Space> 
      <Divider style={{ margin: "12px 0" }} /> 
      <Text strong>Module:</Text> <Text>{bug.Module}</Text>
      <br /> 
      <Text strong>Description:</Text>
      <div style={{ marginTop: 4, marginBottom: 8, maxWidth: "19rem" }}>
        <Text type="secondary">{bug.Description}</Text>
      </div> 
      {bug.Attachments?.length > 0 && (
        <div style={{ marginBottom: 8 }}>
          <Text strong><PaperClipOutlined /> Attachments:</Text>
          <List
            size="small"
            bordered
            dataSource={bug.Attachments}
            renderItem={(file, i) => (
              <List.Item
                style={{ cursor: "pointer", transition: "all 0.2s" }}
                title="Click to open in new tab"
                onClick={() => window.open(`https://workdrive.zoho.com/file/${file}`, "_blank")}
                onMouseEnter={(e) => { e.currentTarget.style.background = "#eaeaea"; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "white"; e.currentTarget.style.borderRadius = "7px" }}
              >
                <Text type="secondary">{file}</Text>
              </List.Item>
            )}
          />
        </div>
      )} 
      {isDev && (  <> <Divider style={{ margin: "10px 0" }} />
          <Space direction="vertical" size={2}>
            <Text type="secondary"><UserOutlined /> Created By: {bug.CREATEDBY}</Text>
            <Text type="secondary">Created On: {modifyTimezoneString(bug.CREATEDTIME, "MM-DD-YYYY")}</Text>
            {bug.MODIFIEDTIME && <Text type="secondary">Modified On: {modifyTimezoneString(bug.MODIFIEDTIME, "MM-DD-YYYY")}</Text>}
          </Space> </> )}

      {!isDev && (
        <div style={{ marginTop: 10 }}>
          <Text type="secondary" style={{ fontSize: 12 }}>
            Submitted on {modifyTimezoneString(bug.CREATEDTIME, "MM-DD-YYYY")}
          </Text>
        </div>
      )}
      <div style={{ marginTop: 10, display: "flex", justifyContent: "space-between", gap:'15px', flexDirection:'row'}}>
        <Button disabled={isDev} color="orange" variant="outlined" size="small" onClick={() => handleEdit(bug)}>Edit Bug</Button>
        <ReportBugActivity bug={bug}/>
        <ReportBugComments bug={bug}/>
      </div>
    </Card>
  );
};

  const content =()=>{
    return(
      <Row>
      <Col xs={24}>
        <Card title="🐞 Bug Management">
          {activeTab==2 && (
            <div style={{ width: "7%",position: "absolute", top: "1rem", right: "0rem"}}> 
              <BugFiltersPopover allBugs={allBugs} setBugs={setBugs} moduleOptions={[
                    "Home","Accounts","Vendors","Contacts","Deals","Tasks",
                    "Leads","Quotes","Accounting","Time Clock","Documents","Calendar","Email"]}
                moduleTreeData={treeData} />
            </div>
          )}
          <Tabs activeKey={activeTab} onChange={setActiveTab} >
            <TabPane tab="Report a Bug" key="1" disabled={isDev}>
              <Form form={form} layout="vertical" onFinish={handleSubmit}>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Title"
                      name="title"
                      rules={[{ required: true, message: "Please enter title" }]}
                    >
                      <Input placeholder="Short summary" />
                    </Form.Item>
                  </Col> 
                  <Col xs={24} md={12}>
                    <Form.Item
                      label="Module"
                      name="module"
                      rules={[{ required: true, message: "Select module" }]}
                    >
                      <CustomTreeSelectWrapper
                        treeData={treeData}
                        placeholder="Select Module"
                        style={{ width: "100%" }}
                        dropdownStyle={{ maxHeight: 360, overflow: 'auto' }}
                        showSearch
                        treeNodeFilterProp="title"
                        allowClear
                        onChange={(value) => {
                          handleTreeSelectChange(value);
                          form.setFieldsValue({ module: value });
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row> 
                <Form.Item label="Attach Screenshots / Recordings">
                  <Row gutter={8}>
                    <Col>
                      <ScreenCapture setFileList={setFileList} onStart={() => setPopoverOpen(false)}
                        onFinish={() => setPopoverOpen(true)}/>
                    </Col> 
                    {fileList.length > 0 && (
                      <Col>
                        <Popover
                          rootClassName="classForUploadFeature"
                          content={attachmentContent}
                          title="Attached Files"
                          trigger="click"
                        >
                          <Button icon={<PaperClipOutlined />}>
                            Attachments ({fileList.length})
                          </Button>
                        </Popover>
                      </Col>
                    )}
                  </Row>
                </Form.Item> 
                <Form.Item
                  label="Description"
                  name="description"
                  rules={[{ required: true, message: "Please enter description" }]}
                >
                  <TextArea rows={5} placeholder="Describe the issue..." />
                </Form.Item> 
                <Row justify="end">
                  <Col>
                    {editingBug && (
                      <Button style={{marginRight: 6}} type="primary" htmlType="reset" onClick={()=>{
                        setEditingBug(null);
                        form.resetFields();
                        setFileList([]);
                      }}>
                        Cancel
                      </Button>
                    )}
                    <Button type="primary" htmlType="submit">
                      {editingBug ? "Update Bug" : "Submit Bug"}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </TabPane>  
            <TabPane tab="View Bugs" key="2">
              {bugs.length === 0 ? (
                <p>No bugs reported yet.</p>
              ) : (
                <>
                {selectedBugIds.length > 0 && (
                  <div style={{
                    marginBottom: 10,
                    padding: 10,
                    background: "#fafafa",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "space-between"
                  }}>
                    <span>{selectedBugIds.length} selected</span>

                    <Space>
                      <Select
                        placeholder="Add to bucket"
                        style={{ width: 200, height:'auto' }}
                        onChange={(bucketName) => {
                        message.success({content: "Adding Bugs to bucket!", key: "submit", duration: 2,});
                        const requests = selectedBugIds.map((id) => AwsServerService.updateBug({ BucketName: bucketName, ROWID: id})); 
                        Promise.all(requests).then(() => {
                            message.success({content: "Bugs added to bucket successfully!", key: "submit", duration: 2,});
                            setSelectedBugIds([]);  
                          }).catch(() => {
                            message.error({content: "Failed to add some bugs to bucket.", key: "submit", duration: 2,});
                          });
                      }}
                      >
                        {Object.keys(buckets).map(bucket => (
                          <Option key={bucket} value={bucket}>{bucket}</Option>
                        ))}
                      </Select>
                    </Space>
                  </div>
                )}
                <List
                  grid={{gutter:2, xs: 2, md: 2, lg: 2 }}
                  dataSource={bugs}
                  renderItem={(bug) => (
                    <List.Item key={bug.ROWID} className="listItemBody" style={{paddingLeft: "8px", paddingRight: "1px" }}>
                      {renderBugCard(bug)}
                    </List.Item>
                  )}
                />
                </>
              )}
            </TabPane> 
            {isDev && (<TabPane tab="Bug Buckets" key="3">
                {Object.keys(buckets).length === 0 && (
                  <p>No buckets created.</p>
                )}
                <Collapse accordion>
                  {Object.keys(buckets).map(bucket => {
                    const renamedBuckets ={
                      HighPriority: "High Priority",
                      MediumPriority: "Medium Priority",
                      LowPriority: "Low Priority",
                      Similar: "Similar Bugs",
                      UnCategorized: "Uncategorized"
                    }
                    return (
                      <Panel 
                      className="classPanelForBugBuckets"
                      style={{fontWeight:'600'}} header={`${renamedBuckets[bucket] || bucket} (${buckets[bucket].length})`} key={bucket}>
                        <List
                          rootClassName="rootClassForBuckets"
                          size="small"
                          dataSource={buckets[bucket]}
                          renderItem={(bug) => (
                            <List.Item>
                              <Space style={{ width: "100%", justifyContent: "space-between" }}> 
                                <Popover 
                                  styles={{
                                    root: {
                                      background: "transparent"
                                    },
                                    body: { height: "400px", width: "400px" ,
                                      background: "transparent",
                                      boxShadow: "none",padding: 0
                                    }
                                  }}
                                  content={renderBugCard(bug)}
                                  trigger="click"
                                  open={activePopoverBugId === bug.ROWID}
                                  onOpenChange={(visible) => {
                                    setActivePopoverBugId(visible ? bug.ROWID : null);
                                    setIsBucketPopoverOpen(visible);
                                  }}
                                >
                                  <BugOutlined style={{ color: "#ff4d4f" }} />
                                  <Text style={{ cursor: "pointer", color: "#4da3ff", marginLeft: 6, }}>
                                    {bug.Title}
                                  </Text>
                                </Popover>

                                <Button
                                  size="small"
                                  danger
                                  onClick={() => {
                          message.success({content: "Removing Bug from bucket!", key: "submit", duration: 2,});
                          AwsServerService.updateBug({ BucketName: "", ROWID: bug.ROWID}).then(() => {
                              message.success({content: "Bug removed from bucket successfully!", key: "submit", duration: 2,});
                             setBuckets(prev => ({...prev,
                            [bucket]: (prev[bucket] || []).filter(item => item.ROWID !== bug.ROWID),
                            UnCategorized: (prev["UnCategorized"] || []).some(item => item.ROWID === bug.ROWID)
                            ? prev["UnCategorized"] : [...prev["UnCategorized"], bug],}));
                            }).catch(() => {
                              message.error({content: "Failed to remove bug from bucket.", key: "submit", duration: 2,});
                            });
                                  }}
                                >
                                  Remove
                                </Button>

                              </Space>
                            </List.Item>
                          )}
                        />
                      </Panel>
                    );
                  })}
                </Collapse>
              {/* </div> */}
            </TabPane>
          )}
          </Tabs>
        </Card>
      </Col>
    </Row>
    )
  }
  return (
    <Popover
    content={content}
    open={popoveropen}
    onOpenChange={(visible) => setPopoverOpen(visible)}
    trigger="click"
    rootClassName="classForReportBugPopover"
    > <div className="BugIcon" onClick={()=>{debugger
        setPopoverOpen(true);
        setEditingBug(null);
        form.resetFields();
        setFileList([]);
        const path = history?.location?.pathname || "";
        const moduleValue = getBreadcrumb(path || "") 
        || moduleMap.find(m => !path.startsWith('/setting') && path.toLowerCase().includes(m.toLowerCase())) 
        || getModuleFromPath(path);
        form.setFieldsValue({ module: moduleValue });
        setRefreshBugs(prev=>!prev)}}>
       🐞 </div> </Popover>
  );
}